import { useDataValue } from 'Simple/Data.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

export function useOnClick(props) {
  let tracking_id = useDataValue({
    context: 'order_status',
    path: 'tracking_id',
    viewPath: props.viewPath,
  })

  let notify = useNotifications()

  return async function onClick() {
    try {
      // eslint-disable-next-line compat/compat
      await navigator.clipboard.writeText(tracking_id)
      notify(notifySuccess('Copied to clipboard'))
    } catch (error) {
      notify(notifyError('Failed to copy to clipboard'))
    }
  }
}
